(function () {
  var styleId = 'mbb-rivyo-overrides';
  var fontFamily = '"Open Sans Condensed", sans-serif';
  var widgetSelector = ':is(.rivyo-main-widget-_r_0_, [class*="rivyo-main-widget"])';
  var selectors = [
    '.wc_review_author_name h6',
    '.wc_review_title h2',
    '.wc_review_item_body_title',
    '.wc_review_summary',
    '.wc_review_summary_action button',
    '.wc_review_summary_action select',
    'li.wc_tab_cls button',
    '.wc_rivyo_actions label',
    '.wc_rivyo_actions select',
    '.wc_review_grid_view',
    '.wc_review_item_body_desc',
    '.wc_review_item_body_desc p',
    '.wc_rivyo_modal_body',
    '.wc_review_btn',
    '.rivyoNotificationBodyTitle',
    '.rivyoNotificationBodyDesc',
    '.rivyoNotificationBodyDesc p',
    '.rivyoNotificationAuthor',
    '.rivyoNotificationAuthor h6',
    '.wcRivyoModal_title h3',
    'form.wc_rivyo_form_contain label',
    'button.wc_rivyo_form_btn',
    '.wc_review_item_product',
    '.wc_review_item_product span',
    '.wc_review_item_product a',
    '.wc_rivyo_btn',
    '.wcRivyoModal p',
    '.rivyoReviewWidget',
    '.wc_review_item_reply h6',
    '.wc_review_item_reply p',
    '.review-summary',
    '.wcProductSummaryModal .wcRivyoModal_header_container',
    '.wcProductSummaryModal .wcRivyoModal_title',
    '.wcProductSummaryModal'
  ];

  function injectRivyoOverrides() {
    var oldStyle = document.getElementById(styleId);
    if (oldStyle) oldStyle.remove();

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = selectors
      .map(function (selector) {
        return widgetSelector + ' ' + selector;
      })
      .join(',\n') + ' {\n  font-family: ' + fontFamily + ' !important;\n}';

    document.head.appendChild(style);
  }

  injectRivyoOverrides();
  document.addEventListener('DOMContentLoaded', injectRivyoOverrides);
  window.addEventListener('load', injectRivyoOverrides);
  setTimeout(injectRivyoOverrides, 1000);
  setTimeout(injectRivyoOverrides, 3000);
})();
